<template>
  <BaseInputText v-bind="style"
                 v-model="input"
                 v-on="$listeners"
                 :inputStyle="inputStyle"
                 :suggested="suggestions.length > 0 && focus"
                 @clear="clearInput"
                 @click-outside="() => { focus = false; }"
                 @focusin="() => { focus = true; }"
                 @focusout="() => {}">
    <template v-slot:popover>
      <BaseOptions v-bind="optionsAttrs"
                   :input="input"
                   :options="suggestions"
                   @selected="selectSuggestion">
        <template v-slot:option="props">
          <slot name="option"
                :index="props.index"
                :option="props.option"
                :text="props.text"
                :textLeft="props.textLeft"
                :textRight="props.textRight">
            <div :style="textContainerStyle">
              <div :style="textLeftStyle">
                {{ props.textLeft}}
              </div>
              <div :style="textStyle">
                {{ props.text }}
              </div>
              <div :style="textRightStyle">
                {{ props.textRight }}
              </div>
            </div>
          </slot>
        </template>
      </BaseOptions>
    </template>
  </BaseInputText>
</template>

<script>
  import BaseInputText from '@base/base-input-text'
  import BaseOptions from '@base/base-options'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'InputTextSecondary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'input',
    },
    components: {
      BaseInputText,
      BaseOptions,
    },
    props: {
      vmodelValue: { type: String },
      suggestions: { type: Array, required: false, default: () => [] },
      popoverZIndex: { type: Number, required: false, default: 10, },
    },
    data: function () {
      return {
        focus: false,
        input: '',
        inputStyle: {
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: {
            '': FontStyle.weight.lg,
            placeholder: FontStyle.weight.md,
          },
          padding: `${Layout.space.sm} ${Layout.space.sm}`,
        },
        optionsAttrs: {
          containerStyle: {
            border: 'none',
            borderRadius: 'none',
            borderWidth: 'none',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
            padding: `${Layout.space.sm} 0`,
            position: 'relative',
          },
          optionContainerStyle: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            height: '32px',
            lineHeight: '32px',
            padding: `0 ${Layout.space.sm}`,
          },
        },
        style: {
          backgroundColor: 'transparent',
          height: '32px',
          innerContainerStyle: {
            borderRadius: 'none',
            borderWidth: '0 0 1px 0',
          },
          ...this.$attrs,
        },
        textContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-start',
        },
        textLeftStyle: {
          fontWeight: FontStyle.weight.lg,
        },
        textRightStyle: {
          fontWeight: FontStyle.weight.lg,
        },
        textStyle: {
          fontWeight: FontStyle.weight.md,
        },
      };
    },
    created: function () {
      this.input = this.vmodelValue;
      this.inputStyle.color = {
        '': this.color.dark2(),
        placeholder: this.color.dark4(),
      };
      this.optionsAttrs.containerStyle = {
        ...this.optionsAttrs.containerStyle,
        backgroundColor: this.color.light1(),
      };
      this.optionsAttrs.optionContainerStyle = {
        ...this.optionsAttrs.optionContainerStyle,
        backgroundColor: {
          '': 'transparent',
          hover: this.color.dark6(),
          disabled: 'transparent',
          'hover-selected': this.color.dark6(),
        },
        ...this.$attrs.optionContainerStyle,
      };
      this.optionsAttrs = {
        ...this.optionsAttrs,
        zIndex: this.popoverZIndex,
        ...this.$attrs.optionsStyle,
      };
      this.style.innerContainerStyle = {
        ...this.style.innerContainerStyle,
        border: {
          '': `solid ${this.color.dark4()}`,
          disabled: 'solid transparent',
          error: `solid ${this.color.warning1()}`,
          focus: `solid ${this.color.action1()}`,
          hover: `solid ${this.color.dark2()}`,
        },
      };
      this.style = {
        ...this.style,
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      clearInput: function () {
        this.input = '';
        this.$emit('input', this.input);
      },
      selectSuggestion: function (suggestionIndex) {
        this.input = this.suggestions[suggestionIndex].display ? this.suggestions[suggestionIndex].display : this.suggestions[suggestionIndex];
        this.$emit('input', this.input);
        this.$emit('selected', suggestionIndex);
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.input = newVal;
      },
    },
  };
</script>
